import { Paper, Typography } from '@mui/material';

export default function EmptyState({ children }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        minHeight: 180,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
        p: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="body2">{children}</Typography>
    </Paper>
  );
}
